<section id="school-levels" class="section reveal reveal--fade-up" s2eReveal aria-labelledby="school-levels-heading">
  <div class="section__head">
    <div class="section__headings">
      <h2 class="section__title" id="school-levels-heading">{{ 'schoolLevel.title' | reportT }}</h2>
      <p class="section__desc">{{ 'schoolLevel.subtitle' | reportT }}</p>
    </div>
  </div>

  <article class="card school-level-card" data-print-block>
    <div class="card-content school-level">
      <!-- Six niveaux nommés sur le côté et 26 codes en pied demandent de la
           place ; en dessous, le graphique défile dans ce conteneur pour que
           le corps de page, lui, ne défile jamais. -->
      <div class="chart-scroll">
        <div class="chart-min chart-min--900">
          <!-- `codePrefix` vide : les codes du modèle sont déjà les codes
               courts affichables (`c1` / `s1` / `م1`), un préfixe les
               doublerait. -->
          <s2e-school-level-chart
            [points]="subject().charts.schoolLevel"
            [scale]="scale()"
            [theme]="chrome.theme()"
            [rtl]="chrome.rtl()"
            [codeDir]="codeDir()"
            [levelLabelHeading]="levelHeading()"
            [ariaLabel]="ariaLabel()"
            codePrefix=""
          />
        </div>
      </div>
    </div>
  </article>
</section>
